

<ng-container *ngIf="!equipmentProviderInActive">
<div class="reviews_wrapper p-b-lg-big p-b-xs-medium-big">
    <div class="flex-row reviews" id="reviews">
        <div class="column-lg-33 text-align-center" *ngFor="let review of reviewsList[reviewPage]">
            <div class="user-review">
                <div class="mark m-b-lg-regular">
                    <!-- <img *ngFor="let star of fakeArray(review.stars)" src="../../../assets/images/icons/icon-rating-star-filled@3x.png'" alt="" loading="lazy">
                    <img *ngFor="let star of fakeArray(5 - review.stars)" src="../../../assets/images/icons/icon-rating-star-stroke.png'" alt="" loading="lazy"> -->
                    <img  *ngFor="let star of fakeArray(review.stars)" [src]="sharedDataService.assetsCdn('images/icons/icon-rating-star-filled@3x.png')" alt="" loading="lazy">
                    <img *ngFor="let star of fakeArray(5 - review.stars)" [src]="sharedDataService.assetsCdn('images/icons/icon-rating-star-stroke.png')" alt="" loading="lazy">
                </div>
                <div class="title m-b-lg-regular m-t-xs-regular">{{review.title}}</div>
                <div class="text m-b-lg-regular m-t-xs-regular">{{review.text}}</div>
                <div class="user-info m-t-xs-regular">— {{review.location
                  ? review.consumer + ' from ' + review.location
                  : review.consumer}}</div>
            </div>
        </div>
    </div>
    <app-component-controls *ngIf="breakpoints.large || breakpoints.extralarge" [navigationStyle]="'dots'" [currentIndex]="reviewPage" [cutBy]="3" [elements]="reviews" [watchElementId]="'reviews'" [animation]="'slide'" (elementsListEvent)="reviewsList = $event"
        (navigateToEvent)="reviewPage = $event"></app-component-controls>
    <app-component-controls *ngIf="breakpoints.extraSmall" [navigationStyle]="'dots'" [currentIndex]="reviewPage" [cutBy]="2" [elements]="reviews" [watchElementId]="'reviews'" [animation]="'slide'" (elementsListEvent)="reviewsList = $event" (navigateToEvent)="reviewPage = $event"></app-component-controls>
</div>
</ng-container>

<ng-container *ngIf="equipmentProviderInActive">
    <div class="reviews_wrapper p-b-lg-small p-b-xs-medium-big">
        <div class="flex-row reviews" id="reviews">

            <div class="column-lg-100 text-align-center p-b-lg-big">
                <img *ngIf="breakpoints.large || breakpoints.extraLarge" [src]="sharedDataService.assetsCdn('images/icons/what_customers_are_saying_updated_8.13.2025.svg')" 
                style="height: 9.2rem !important;width: 62rem !important;" loading="lazy" alt="">
                <img *ngIf="breakpoints.small || breakpoints.extraSmall" [src]="sharedDataService.assetsCdn('images/icons/what_customers_are_saying_updated_8.13.2025.svg')" 
                style="width: 340px;height: 134.04px;padding-bottom: 2rem;" loading="lazy" alt="">
            </div>

            <div class="column-lg-33 text-align-center" *ngFor="let review of reviewsList[reviewPage];let i = index;">
                <div class="user-review">
                    <div style="padding-bottom: 1rem;">
                        <img  [src]="getImagePath(i+1)" style="border-radius: 50%;width: 7.5rem !important;" loading="lazy" alt="">
                    </div>
                    <div class="mark m-b-lg-regular">
                        <!-- <img *ngFor="let star of fakeArray(review.stars)" src="../../../assets/hsfs/images/icons/icon-rating-star-filled@3x.png'" alt="" loading="lazy">
                        <img *ngFor="let star of fakeArray(5 - review.stars)" src="../../../assets/hsfs/images/icons/icon-rating-star-stroke.png'" alt="" loading="lazy"> -->
                        <img style="width:3rem!important" *ngFor="let star of fakeArray(review.stars)" [src]="sharedDataService.assetsCdn('images/icons/icon-hsfs-star-filled.svg')" alt="" loading="lazy">
                        <img *ngFor="let star of fakeArray(5 - review.stars)" [src]="sharedDataService.assetsCdn('images/icons/icon-rating-star-stroke.png')" alt="" loading="lazy">
                    </div>
                    <div style="font-size: 1.75rem !important;" class="title equip m-b-lg-regular m-t-xs-regular">{{review.title}}</div>
                    <div style="font-size: 1.75rem !important;"  class="text equip m-b-lg-medium-big  m-t-xs-regular" [innerHTML]="review.text"></div>
                    <div class="user-info equip m-t-xs-regular">— {{review.location
                      ? review.consumer + ' from ' + review.location
                      : review.consumer}}</div>
                </div>  
            </div>
        </div>
         <app-component-controls *ngIf="breakpoints.large || breakpoints.extralarge" 
         [navigationStyle]="'dots'" [currentIndex]="reviewPage" [cutBy]="3" 
         [elements]="reviews" [watchElementId]="'reviews'" [animation]="'slide'" 
         (elementsListEvent)="reviewsList = $event"
            (navigateToEvent)="reviewPage = $event">
        </app-component-controls>
        
        <app-component-controls *ngIf="breakpoints.extraSmall" 
        [navigationStyle]="'dots'" [currentIndex]="reviewPage"
         [cutBy]="2" [elements]="reviews" [watchElementId]="'reviews'"
          [animation]="'slide'" (elementsListEvent)="reviewsList = $event" 
          (navigateToEvent)="reviewPage = $event">
        </app-component-controls>  
    </div>
    </ng-container>
    